module.exports = __webpack_public_path__ + "img/bohrungen-2.607e0c93.png";